<template>
  <div class="document">
    <div class="header">
      <EsHeader>
        <template #header>
          Duplicate IDs
        </template>
      </EsHeader>
    </div>
    <div class="content">
      <es-form style="padding: 1.15rem 0rem; margin: 0">
        <template #es-form-header>
          <div class="header-container">
            <strong class="title is-6">
              What is a duplicate IDs?
            </strong>
          </div>
          <div class="description">
            A duplicate ID happens when the same person is assigned two different identifiers.
            This can happen when the Matching Engine or a user assigns a new identifier to a
            person when the record should have been a Match.
            This issue should be resolved by retiring and merging records.
          </div>
        </template>
        <template #es-form>
          <table>
            <thead>
              <tr>
                <th
                  class="top-row"
                  style="padding-left:0"
                >
                  Option
                </th>
                <th class="top-row action">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="property">
                <td class="option">
                  Search for Duplicate IDs
                </td>
                <td class="action">
                  <router-link
                    :to="{ name: 'PIDuplicateSearch', query: { search: 'session' } }"
                    :class="{ 'disabled': !hasModule('PRSID:IDENT:DUPLICATES:VIEW')}"
                  >
                    Search
                  </router-link>
                </td>
              </tr>
              <tr class="property">
                <td class="option">
                  Review Duplicate Queue
                </td>
                <td class="action">
                  <router-link
                    :to="{ name: 'PIDuplicateSearch', query: { search: 'queue' } }"
                    :class="{ 'disabled': !hasModule('PRSID:IDENT:DUPLICATES:VIEW')}"
                  >
                    View
                  </router-link>
                </td>
              </tr>
              <tr class="property">
                <td class="option">
                  Retire / Merge an ID
                </td>
                <td class="action">
                  <router-link
                    :to="{ name: 'PIRetireMerge' }"
                    :class="{ 'disabled': !hasModule('PRSID:IDENT:RETIREID')}"
                  >
                    Retire
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </template>
      </es-form>
    </div>
  </div>
</template>

<script>
import EsForm from '@/components/EsForm.vue';
import EsHeader from '@/components/EsHeader.vue';
import PermissionManager from '@/mixins/PermissionManager';

export default {
  mixins: [
    PermissionManager,
  ],
  components: {
    EsForm,
    EsHeader,
  },
};
</script>

<style lang="sass" scoped>
  table th
    border-bottom: 1px solid #eee
  table td
    border-bottom: 1px solid #eee
  .action
    padding-right: 0
    text-align: right !important
  .description
    text-align: left
    margin-left: -1rem
    font-size: 12px
  .option
    padding-left: 0
    color: #212529
  .property
    font-size: 12px
  .top-row
    padding-top: 2rem
    font-size: 12px
    color: #666
  a.disabled
    color: #999
    cursor:  default
    text-decoration:  none
    pointer-events: none
    &:hover
      text-decoration:  none
</style>
